export default __webpack_public_path__ + "static/bicicletario-8258d9cccd1f90d8c1db929d8309e72e.jpg";